import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getBreadcrumbs = state => get(state, 'searchAndBrowse.breadcrumbs', []);

const getFinalBreadcrumb = createSelector([getBreadcrumbs], breadcrumbs =>
  breadcrumbs ? breadcrumbs[breadcrumbs.length - 1] : null,
);

export const getParentOfferName = createSelector([getFinalBreadcrumb], finalBreadcrumb =>
  finalBreadcrumb ? finalBreadcrumb.name : undefined,
);

export const getParentOfferPath = createSelector([getFinalBreadcrumb], finalBreadcrumb =>
  finalBreadcrumb ? finalBreadcrumb.path : undefined,
);
